export { FastshiftTable } from "./src/fastshift-table";
export { DEFAULT_CONTROLS_PAYLOAD } from "./src/constants";
export type {
    OnSetControlsPayload,
    TableRows,
    TableHeads,
    ControlsPayload,
    Pagination,
    SortDirection
} from "./src/types";
